<template>
  <div>
    <div>
      <b-row class="table-bottom-wrapper m-2 mx-0">
        <b-col lg="2" sm="12" class="px-0">
          <b-button
            data-v-step="4"
            @click="viewCertificate"
            size="sm"
            :class="{
              'box-shadow2 btn btn-success mr-2': !isDarkMode,
              'btn btn-primary text-light mr-2': isDarkMode
            }"
          >
            <font-awesome-icon :icon="['fas', 'edit']" class="mr-1" />View Certificate List
          </b-button>
        </b-col>
        <b-col lg="2" sm="12" class="px-0">
          <b-button
            data-v-step="4"
            @click="viewCashList"
            size="sm"
            :class="{
              'box-shadow2 btn btn-success mr-2': !isDarkMode,
              'btn btn-primary text-light mr-2': isDarkMode
            }"
          >
            <font-awesome-icon :icon="['fas', 'edit']" class="mr-1" />View Cash List
          </b-button>
        </b-col>
      </b-row>
      <div>
        <div>
          <div
            :class="{
              ' my-4 rounded': !isDarkMode,
              '  my-4 bg-dark rounded text-light': isDarkMode
            }"
          >
            <div>
              <div
                :class="{
                  'box-shadow2 my-3': !isDarkMode,
                  ' my-3': isDarkMode
                }"
              >
                <div
                  :class="{
                    'table-row table-row-header text-center': !isDarkMode,
                    'table-row-dark text-center dark-div border-top': isDarkMode
                  }"
                >
                  <div
                    v-for="column in columns"
                    :key="column.id"
                    :class="{ 'table-column bg-light': !isDarkMode, 'table-column-dark': isDarkMode }"
                    :style="columnStyle(column)"
                  >
                    {{ column.headerText }}
                  </div>
                </div>
                <b-overlay v-if="loading" show :variant="isDarkMode ? 'outline-light' : 'outline-secondary'">
                  <div
                    :class="{ 'table-row table-row-empty': !isDarkMode, 'table-row-dark table-row-empty': isDarkMode }"
                  >
                    <div
                      :class="{
                        'table-column table-column-full text-center': !isDarkMode,
                        'table-column-dark table-column-full text-center': isDarkMode
                      }"
                    >
                    </div>
                  </div>
                </b-overlay>
                <div
                  :class="{
                    'table-row text-center ': !isDarkMode,
                    'table-row-dark text-center': isDarkMode
                  }"
                  v-for="(row, index) in rows"
                  :key="row.id"
                >
                  <div
                    v-for="column in columns"
                    :key="column.id"
                    :class="{ 'table-column': !isDarkMode, 'table-column-dark': isDarkMode }"
                    :style="columnStyle(column)"
                  >
                    <slot v-if="column.slotKey" :name="column.slotKey" v-bind:row="row"></slot>
                    <div v-if="column.htmlKey" v-html="row[column.htmlKey]"></div>
                    <div v-if="column.urlKey"
                      ><a :href="row[column.urlKey]" target="_blank">{{ row[column.urlKey] }}</a></div
                    >
                    <div v-if="column.textKey === 'index'">
                      <span class="span-text">{{ index + 1 }}</span>
                    </div>
                    <div>
                      <span class="span-text">{{ row[column.textKey] }}</span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="rows.length === 0"
                  :class="{ 'table-row table-row-empty': !isDarkMode, 'table-row-dark table-row-empty': isDarkMode }"
                >
                  <div
                    :class="{
                      'table-column table-column-full text-center': !isDarkMode,
                      'table-column-dark table-column-full text-center': isDarkMode
                    }"
                    >{{ emptyText }}</div
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import router from '@/router';

export default {
  name: 'DashboardListBox',
  props: {
    columns: Array,
    rows: Array
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('pettyCash', ['loading']),
    metaDescription() {
      return 'Dashboard List';
    }
  },
  data() {
    return {
      emptyText: 'no data found'
    };
  },
  methods: {
    viewCertificate() {
      router.push('/petty-cash/certificate');
    },
    viewCashList() {
      router.push('/petty-cash/certificate/cc/upload');
    },
    columnStyle(column) {
      return { width: column.width };
    }
  }
};
</script>

<style src="../../../assets/css/Table.css"></style>
<style>
.bold {
  font-weight: bolder;
}
</style>
